<div class="useful-weeks-container">
  <div class="header">
    <h1>Useful Weeks</h1>
    <mat-icon
      class="info-icon"
      matTooltip="Tracks the number of weeks used out of the 80 available.​"
      matTooltipPosition="above"
    >
      info
    </mat-icon>
  </div>

  <div style="display: flex; align-items: baseline">
    <div class="progress-info">
      <span class="progress-text">{{ weeksProgress }} of {{ maxWeeks }}</span>
    </div>

    <div class="progress-bar-container">
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(weeksProgress / maxWeeks) * 100"
        ></div>
      </div>
    </div>
  </div>
</div>
